import { ComponentsImports } from '@shared/app/model/ComponentsImports';

const components: ComponentsImports = {
  Box: () => import('@shared/layout/ui/Box.vue'),
  AutoFlex: () => import('@shared/layout/ui/AutoFlex.vue'),
  AutoAbsolute: () => import('@shared/layout/ui/AutoAbsolute.vue'),
  Alternate: () => import('@shared/layout/ui/alternate/Alternate.vue'),

  TwoRows5050: () => import('@/shared/layout/ui/TwoRows5050.vue'),
  TwoRows1585: () => import('@/shared/layout/ui/TwoRows1585.vue'),
  TwoRows2278: () => import('@/shared/layout/ui/TwoRows2278.vue'),

  TwoCols5050: () => import('@shared/layout/ui/TwoCols5050.vue'),
  ThreeCols333333: () => import('@shared/layout/ui/ThreeCols333333.vue'),
};

export default components;
